import { defineStore } from 'pinia'
import { ApplicationConfigService } from '~/libs/store-services/application-config-service'

import { useBorrowerStore } from '~/store/borrower'
import { useRootStore } from '~/store/root'

// import get from 'lodash/get'
// import env from '~/libs/env'
// import { ref, computed } from 'vue'

export const useApplicationConfigStore = defineStore('applicationConfig', () => {
  const nuxtApp = useNuxtApp();
  const { $axios } = nuxtApp;
  const applicationConfigService = new ApplicationConfigService($axios)
  const borrowerStore = useBorrowerStore()
  const rootStore = useRootStore()
  let stale = true

  /*
  ███████ ████████  █████  ████████ ███████
  ██         ██    ██   ██    ██    ██
  ███████    ██    ███████    ██    █████
       ██    ██    ██   ██    ██    ██
  ███████    ██    ██   ██    ██    ███████
  STATE
  */
  const applicationConfig = ref(null)
  const navItems = ref([])
  const baseRoute = ref('/form')


  /*
   ██████  ███████ ████████ ████████ ███████ ██████  ███████
  ██       ██         ██       ██    ██      ██   ██ ██
  ██   ███ █████      ██       ██    █████   ██████  ███████
  ██    ██ ██         ██       ██    ██      ██   ██      ██
   ██████  ███████    ██       ██    ███████ ██   ██ ███████
  GETTERS
  */

  /*
   █████   ██████ ████████ ██  ██████  ███    ██ ███████
  ██   ██ ██         ██    ██ ██    ██ ████   ██ ██
  ███████ ██         ██    ██ ██    ██ ██ ██  ██ ███████
  ██   ██ ██         ██    ██ ██    ██ ██  ██ ██      ██
  ██   ██  ██████    ██    ██  ██████  ██   ████ ███████
  ACTIONS
  ! - - Actions calling other actions in the same store must use `this.actionName(...)`
  ! - - If we do not use `this.actionName` it will not be properly mockable in tests.
  ! - - Computeds and refs will work fine, and should be called directly though.
  */
  async function getByIdentifier({ identifier }) {
    // return previously loaded value if we have it
    if (!stale && applicationConfig.value) {
      return applicationConfig.value
    }
    stale = false

    const borrower = await borrowerStore.getBorrower()
    const borrowerId = borrower?.id

    const _applicationConfig = await applicationConfigService.getByIdentifier({ identifier, borrowerId })

    if (!borrowerId) {
      // In an unauth'd scenario, if we're using localStorage inject answers if we have no borrowerId
    }

    // update applicationConfig state
    applicationConfig.value = _applicationConfig

    // update navItems
    navItems.value = _applicationConfig.modules.map((module) => {
      return {
        url: `${baseRoute.value}/${identifier}/${module.urlSlug}`,
        label: module.displayName
      }
    })

    // return config
    return applicationConfig.value
  }

  async function saveAnswers({ answers: _answers = null } = {}) {
    if (!Object.keys(_answers).length) {
      return
    }

    const data = await applicationConfigService.saveAnswers({
      authenticated: Boolean(rootStore.authUser),
      answers: _answers,
      borrowerId: borrowerStore.borrowerId
    })
    stale = true

    if (data) {
      return Object.keys(_answers)
    }

    return []
  }

  return {
    // STATE
    applicationConfig,
    navItems,
    baseRoute,

    // GETTERS

    // ACTIONS
    getByIdentifier,
    saveAnswers
  }
})
